import { Accordion } from "../components/accordion";
import { FloatLabel } from "../components/floatingLabel";

// Issue when submiting AJAX form -> Convert to vanilla if you DARE !!
jQuery(document).bind("gform_post_render", function () {
	FloatLabel.init();
});

document.addEventListener("DOMContentLoaded", (e) => {
	FloatLabel.init();
	Accordion.init();
});
